import mapSimpleSubcategory from './mapSimpleSubcategory';
import mapSimpleCategory from './mapSimpleCategory';

const fabricOption = [
  {
    id: 4191,
    sku: '-CF426',
    value: 'Chance Charcoal',
    additional_cost: 0,
    __typename: 'OptionValue',
  },
  {
    id: 4194,
    sku: '-CF429',
    value: 'Laguna Pepper',
    additional_cost: 150,
    __typename: 'OptionValue',
  },
  {
    id: 4193,
    sku: '-CF428',
    value: 'Laguna Beach',
    additional_cost: 150,
    __typename: 'OptionValue',
  },
  {
    id: 4192,
    sku: '-CF427',
    value: 'Laguna Amber',
    additional_cost: 150,
    __typename: 'OptionValue',
  },
  {
    id: 4181,
    sku: '-CF417',
    value: 'Nova Sunflower',
    additional_cost: 0,
    __typename: 'OptionValue',
  },
  {
    id: 4056,
    sku: '-CF406',
    value: 'Origin Mist',
    additional_cost: 0,
    __typename: 'OptionValue',
  },
  {
    id: 4180,
    sku: '-CF416',
    value: 'Prime Peacock',
    additional_cost: 150,
    __typename: 'OptionValue',
  },
  {
    id: 4185,
    sku: '-CF420',
    value: 'Royale Ash',
    additional_cost: 150,
    __typename: 'OptionValue',
  },
  {
    id: 4176,
    sku: '-CF412',
    value: 'Synergy Pewter',
    additional_cost: 0,
    __typename: 'OptionValue',
  },
  {
    id: 4164,
    sku: '-CF410',
    value: 'Royale Cobalt',
    additional_cost: 150,
    __typename: 'OptionValue',
  },
  {
    id: 4029,
    sku: '-CF387',
    value: 'Royale Blush',
    additional_cost: 150,
    __typename: 'OptionValue',
  },
  {
    id: 4035,
    sku: '-CF393',
    value: 'Merit Dove',
    additional_cost: 0,
    __typename: 'OptionValue',
  },
  {
    id: 4030,
    sku: '-CF388',
    value: 'Royale Gunmetal',
    additional_cost: 150,
    __typename: 'OptionValue',
  },
  {
    id: 4031,
    sku: '-CF389',
    value: 'Royale Evergreen',
    additional_cost: 150,
    __typename: 'OptionValue',
  },
  {
    id: 262,
    sku: '-CF033',
    value: 'Bentley Daisey',
    additional_cost: 225,
    __typename: 'OptionValue',
  },
  {
    id: 2207,
    sku: '-CF145',
    value: 'Bentley Indigo',
    additional_cost: 225,
    __typename: 'OptionValue',
  },
  {
    id: 4044,
    sku: '-CF402',
    value: 'Royale Peacock ',
    additional_cost: 150,
    __typename: 'OptionValue',
  },
  {
    id: 2738,
    sku: '-CF255',
    value: 'Bentley Pewter',
    additional_cost: 225,
    __typename: 'OptionValue',
  },
  {
    id: 3828,
    sku: '-CF351',
    value: 'Cody Pacific',
    additional_cost: 225,
    __typename: 'OptionValue',
  },
  {
    id: 4046,
    sku: '-CF404',
    value: 'Sunbrella Premier Lagoon ',
    additional_cost: 225,
  },
  {
    id: 3827,
    sku: '-CF350',
    value: 'Cody Sandstone',
    additional_cost: 225,
    __typename: 'OptionValue',
  },
  {
    id: 785,
    sku: '-CF013',
    value: 'Cordova Amber',
    additional_cost: 150,
    __typename: 'OptionValue',
  },
  {
    id: 265,
    sku: '-CF015',
    value: 'Cordova Eclipse',
    additional_cost: 150,
    __typename: 'OptionValue',
  },
  {
    id: 2149,
    sku: '-CF011',
    value: 'Cordova Mineral',
    additional_cost: 150,
    __typename: 'OptionValue',
  },
  {
    id: 267,
    sku: '-CF014',
    value: 'Cordova Picante',
    additional_cost: 150,
    __typename: 'OptionValue',
  },
  {
    id: 2908,
    sku: '-CF261',
    value: 'Dawson Brindle',
    additional_cost: 150,
    __typename: 'OptionValue',
  },
  {
    id: 3514,
    sku: '-CF313',
    value: 'Dawson Slate',
    additional_cost: 150,
    __typename: 'OptionValue',
  },
  {
    id: 3531,
    sku: '-CF333',
    value: 'Essence Aqua',
    additional_cost: 0,
    __typename: 'OptionValue',
  },
  {
    id: 3537,
    sku: '-CF339',
    value: 'Essence Ash',
    additional_cost: 0,
    __typename: 'OptionValue',
  },
  {
    id: 3515,
    sku: '-CF314',
    value: 'Impact Flurry',
    additional_cost: 150,
    __typename: 'OptionValue',
  },
  {
    id: 3516,
    sku: '-CF316',
    value: 'Impact Mist',
    additional_cost: 150,
    __typename: 'OptionValue',
  },
  {
    id: 268,
    sku: '-CF027',
    value: 'Key Largo Ash',
    additional_cost: 150,
    __typename: 'OptionValue',
  },
  {
    id: 2128,
    sku: '-CF063',
    value: 'Key Largo Bubblegum',
    additional_cost: 150,
  },
  {
    id: 271,
    sku: '-CF020',
    value: 'Key Largo Coral',
    additional_cost: 150,
    __typename: 'OptionValue',
  },
  {
    id: 2136,
    sku: '-CF071',
    value: 'Key Largo Denim',
    additional_cost: 150,
    __typename: 'OptionValue',
  },
  {
    id: 273,
    sku: '-CF019',
    value: 'Key Largo Grass',
    additional_cost: 150,
    __typename: 'OptionValue',
  },
  {
    id: 2133,
    sku: '-CF068',
    value: 'Key Largo Ruby',
    additional_cost: 150,
    __typename: 'OptionValue',
  },
  {
    id: 2129,
    sku: '-CF064',
    value: 'Key Largo Zenith Teal',
    additional_cost: 0,
  },
  {
    id: 2209,
    sku: '-CF147',
    value: 'Lucky Divine',
    additional_cost: 150,
    __typename: 'OptionValue',
  },
  {
    id: 298,
    sku: '-CF041',
    value: 'Lucky Turquoise',
    additional_cost: 0,
    __typename: 'OptionValue',
  },
  {
    id: 2924,
    sku: '-CF180',
    value: 'Notion Appletini',
    additional_cost: 150,
    __typename: 'OptionValue',
  },
  {
    id: 3521,
    sku: '-CF323',
    value: 'Notion Gunsmoke',
    additional_cost: 150,
    __typename: 'OptionValue',
  },
  {
    id: 3824,
    sku: '-CF347',
    value: 'Sunbrella Premier Fog',
    additional_cost: 225,
  },
  {
    id: 3825,
    sku: '-CF348',
    value: 'Sunbrella Premier Indigo',
    additional_cost: 225,
  },
  {
    id: 2942,
    sku: '-CF200',
    value: 'Taylor Felt Grey',
    additional_cost: 0,
    __typename: 'OptionValue',
  },
  {
    id: 2943,
    sku: '-CF201',
    value: 'Taylor Golden',
    additional_cost: 0,
    __typename: 'OptionValue',
  },
  {
    id: 2945,
    sku: '-CF203',
    value: 'Taylor Tonic',
    additional_cost: 0,
    __typename: 'OptionValue',
  },
  {
    id: 2881,
    sku: '-CF191',
    value: 'Vibe Aquatic',
    additional_cost: 150,
    __typename: 'OptionValue',
  },
  {
    id: 2948,
    sku: '-CF194',
    value: 'Vibe Sunkist',
    additional_cost: 150,
    __typename: 'OptionValue',
  },
  {
    id: 4241,
    sku: '-NF003',
    value: 'Antonio Pool',
    additional_cost: 0,
    __typename: 'OptionValue',
  },
  {
    id: 4252,
    sku: '-NF014',
    value: 'Antonio Cedar',
    additional_cost: 0,
    __typename: 'OptionValue',
  },
  {
    id: 4359,
    sku: '-CF435',
    value: 'Milo Burgundy',
    additional_cost: 0,
    __typename: 'OptionValue',
  },
  {
    id: 4360,
    sku: '-CF436',
    value: 'Milo Dove',
    additional_cost: 0,
    __typename: 'OptionValue',
  },
  {
    id: 4361,
    sku: '-CF437',
    value: 'Milo French Blue ',
    additional_cost: 0,
    __typename: 'OptionValue',
  },
  {
    id: 4362,
    sku: '-CF438',
    value: 'Royale Forest',
    additional_cost: 0,
    __typename: 'OptionValue',
  },
  {
    id: 4365,
    sku: '-CF441',
    value: 'Faithful Olive',
    additional_cost: 0,
    __typename: 'OptionValue',
  },
  {
    id: 4366,
    sku: '-CF442',
    value: 'Faithful Indigo ',
    additional_cost: 0,
    __typename: 'OptionValue',
  },
];

const woodOptions = [
  {
    id: 757,
    sku: '-WS03',
    value: 'Mocha',
    additional_cost: 0,
    __typename: 'OptionValue',
  },
  {
    id: 755,
    sku: '-WS02',
    value: 'Medium',
    additional_cost: 0,
    __typename: 'OptionValue',
  },
  {
    id: 754,
    sku: '-WS04',
    value: 'Coffee Bean',
    additional_cost: 0,
    __typename: 'OptionValue',
  },
];
const orientationOptions = [
  {
    id: 106,
    sku: '-laf',
    value: 'Left',
    additional_cost: 0,
    __typename: 'OptionValue',
  },
  {
    id: 107,
    sku: '-raf',
    value: 'Right',
    additional_cost: 0,
    __typename: 'OptionValue',
  },
];

const legOptions = [
  {
    id: 4210,
    sku: '-CNLGS',
    value: 'Cone Legs',
    additional_cost: 0,
    __typename: 'OptionValue',
  },
];

const chairWoodOptions = [
  {
    id: 3695,
    sku: '-W03',
    value: 'Walnut',
    additional_cost: 0,
    __typename: 'OptionValue',
  },
  {
    id: 3694,
    sku: '-W02',
    value: 'Cherry',
    additional_cost: 0,
    __typename: 'OptionValue',
  },
  {
    id: 3693,
    sku: '-W01',
    value: 'Maple',
    additional_cost: 0,
    __typename: 'OptionValue',
  },
];
const leatherOptions = [
  {
    id: 4026,
    sku: '-CL038',
    value: 'Academy Cuero',
    additional_cost: 0,
    __typename: 'OptionValue',
  },
  {
    id: 4025,
    sku: '-CL037',
    value: 'Colonade Sycamore',
    additional_cost: 0,
    __typename: 'OptionValue',
  },
];

const shopCategories = [
  mapSimpleCategory({
    categoryTitle: 'Dining Room',
    subcategories: [
      {
        subcategoryTitle: 'Dining Tables',
        link: '/dining-tables',
        imageUrl:
          'https://joybird2.imgix.net/product_hero/9801/9801-remy-dining-table-t1-2_ts.png',
      },
      {
        subcategoryTitle: 'Dining Chairs',
        link: '/dining-chairs',
        imageUrl:
          'https://joybird2.imgix.net/product_hero/9796/9796-joyce-%28blush%29-dining-chair-t1-2_ts.png',
      },
      {
        subcategoryTitle: 'Bar Carts & Cabinets',
        link: '/bar-carts-cabinets',
        imageUrl:
          'https://joybird2.imgix.net/product_hero/9791/9791-piper-cabinet-t1-1_ts.png',
      },
      {
        subcategoryTitle: 'All Dining Room Furniture',
        link: '/dining-room-furniture',
        imageUrl:
          'https://joybird2.imgix.net/configurations/pid_1925/-CF200-W03/1925-CF200-W03-toscano-dining-set-taylor-felt-grey-t1-1_t.png',
      },
    ],
  }),
  {
    categoryTitle: 'Sofas & Sectionals',
    subcategory: [
      {
        subcategoryTitle: 'Sofas',
        link: '/sofas',
        products: {
          products: [
            {
              id: 9514,
              name: 'Lewis Sofa',
              hero_images_min: [
                {
                  sort_order: 1,
                  url:
                    'https://joybird2.imgix.net/product_hero/9514/Lewis-Sofa-Merit-Dove-T3-054.jpg',
                  __typename: 'HeroImage',
                },
              ],
              images: [
                {
                  sort_order: 1,
                  url:
                    'https://pv.imgix.net/public_img/Lewis-Sofa-Merit-Dove-T1-008.jpg',
                  __typename: 'Image',
                },
              ],
              options: [
                {
                  default_value: '2942',
                  name: 'Fabric',
                  id: 17,
                  popular_values: ['2942', '3824', '4164', '2129'],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: fabricOption,
                      variant_id: 175873,
                    },
                  ],
                },
                {
                  default_value: '757',
                  name: 'Wood Stain',
                  id: 19,
                  popular_values: [],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: woodOptions,
                      variant_id: 175874,
                    },
                  ],
                },
                {
                  default_value: '4210',
                  name: 'Leg Option',
                  id: 135,
                  popular_values: [],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: legOptions,
                      variant_id: 175952,
                    },
                  ],
                },
              ],
              sku: 'JB14041300',
              slug: 'lewis-sofa',
              type: {
                name: 'Sofa',
              },
              fabricSku: '-CF033',
            },
          ],
        },
      },
      {
        subcategoryTitle: 'Sectional Sofas',
        link: '/sectionals',
        products: {
          products: [
            {
              id: 9511,
              name: 'Lewis Sectional',
              hero_images_min: [
                {
                  sort_order: 1,
                  url:
                    'https://joybird2.imgix.net/product_hero/9511/Lewis-Sectional-Royale-Evergreen-T2-051.jpg',
                  __typename: 'HeroImage',
                },
              ],
              images: [
                {
                  sort_order: 1,
                  url:
                    'https://pv.imgix.net/public_img/Lewis-Sectional-Essence-Ash-T1-076.jpg',
                  __typename: 'Image',
                },
              ],
              options: [
                {
                  default_value: '2942',
                  name: 'Fabric',
                  id: 17,
                  popular_values: ['2942', '3824', '4164', '2129'],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: fabricOption,
                      variant_id: 175865,
                    },
                  ],
                },
                {
                  default_value: '757',
                  name: 'Wood Stain',
                  id: 19,
                  popular_values: [],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: woodOptions,
                      variant_id: 175866,
                    },
                  ],
                },
                {
                  default_value: '107',
                  name: 'Orientation',
                  id: 16,
                  popular_values: [],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: orientationOptions,
                      variant_id: 175864,
                    },
                  ],
                },
                {
                  default_value: '4210',
                  name: 'Leg Option',
                  id: 135,
                  popular_values: [],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: legOptions,
                      variant_id: 175951,
                    },
                  ],
                },
              ],
              sku: 'JB14038870',
              slug: 'lewis-sectional',
              type: {
                name: 'Sectional',
              },
              fabricSku: '-CF020',
            },
          ],
        },
      },
      {
        subcategoryTitle: 'Sleeper Sofas',
        link: '/sleeper-sofas',
        products: {
          products: [
            {
              id: 8696,
              name: 'Hughes Sleeper Sofa',
              hero_images_min: [
                {
                  sort_order: 1,
                  url:
                    'https://joybird2.imgix.net/product_hero/8696/Hughes-Sleeper-Sofa-Laguna-Pepper-T2-126.jpg',
                  __typename: 'HeroImage',
                },
              ],
              images: [
                {
                  sort_order: 1,
                  url:
                    'https://pv.imgix.net/public_img/Hughes-Sleeper-Sofa-Laguna-Pepper-T1-131.jpg',
                  __typename: 'Image',
                },
              ],
              price: 3149,
              options: [
                {
                  default_value: '2942',
                  name: 'Fabric',
                  id: 17,
                  popular_values: ['2942', '3824', '4164', '2129'],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: fabricOption,
                      variant_id: 175015,
                    },
                  ],
                },
                {
                  default_value: '757',
                  name: 'Wood Stain',
                  id: 19,
                  popular_values: [],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: woodOptions,
                      variant_id: 174990,
                    },
                  ],
                },
              ],
              sku: 'JB13654380',
              slug: 'hughes-sleeper-sofa',
              type: {
                name: 'Sleeper Sofa',
              },
              fabricSku: '-CF200',
            },
          ],
        },
      },

      {
        subcategoryTitle: 'Apartment Sofas',
        link: '/apartment-sofas',
        products: {
          products: [
            {
              id: 9289,
              name: 'Chelsea Apartment Sofa',
              hero_images_min: [
                {
                  sort_order: 1,
                  url:
                    'https://joybird2.imgix.net/product_hero/9289/Chelsea-Apartment-Sofa-Dunhill-Sand-T1-462.jpg',
                  __typename: 'HeroImage',
                },
              ],
              images: [
                {
                  sort_order: 1,
                  url:
                    'https://pv.imgix.net/public_img/Chelsea-Apartment-Sofa-Dunhill-Sand-T1-462.jpg',
                  __typename: 'Image',
                },
              ],
              options: [
                {
                  default_value: '2942',
                  name: 'Fabric',
                  id: 17,
                  popular_values: ['2942', '3824', '4164', '2129'],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: fabricOption,
                      variant_id: 175610,
                    },
                  ],
                },
                {
                  default_value: '757',
                  name: 'Wood Stain',
                  id: 19,
                  popular_values: [],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: woodOptions,
                      variant_id: 175611,
                    },
                  ],
                },
              ],
              sku: 'JB13864910',
              slug: 'chelsea-apartment-sofa',
              type: {
                name: 'Apartment Sofa',
              },
              fabricSku: '-CF333',
            },
          ],
        },
      },
      {
        subcategoryTitle: 'Apartment Sectionals',
        link: '/apartment-sectionals',
        products: {
          products: [
            {
              id: 8737,
              name: 'Eliot Apartment Corner Sectional (3 piece)',
              hero_images_min: [
                {
                  sort_order: 1,
                  url:
                    'https://joybird2.imgix.net/product_hero/8737/Eliot-Corner-Sectional-Taylor-Felt-Grey-T1-337.jpg',
                  __typename: 'HeroImage',
                },
              ],
              images: [
                {
                  sort_order: 1,
                  url:
                    'https://pv.imgix.net/public_img/Gallery-Eliot-Corner-Sectional-1.jpg',
                  __typename: 'Image',
                },
              ],
              price: 3099,
              options: [
                {
                  default_value: '2942',
                  name: 'Fabric',
                  id: 17,
                  popular_values: ['2942', '3824', '4164', '2129'],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: fabricOption,
                      variant_id: 175069,
                    },
                  ],
                },
                {
                  default_value: '757',
                  name: 'Wood Stain',
                  id: 19,
                  popular_values: [],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: woodOptions,
                      variant_id: 175070,
                    },
                  ],
                },
              ],
              sku: 'JB13695360',
              slug: 'eliot-apartment-corner-sectional',
              type: {
                name: 'Apartment Corner Sectional',
              },
              fabricSku: '-CF033',
            },
          ],
        },
      },
      {
        subcategoryTitle: 'Modular Sofas',
        link: '/modular-sofas',
        products: {
          products: [
            {
              id: 8153,
              name: 'Bryant Ottoman',
              hero_images_min: [
                {
                  sort_order: 1,
                  url:
                    'https://joybird2.imgix.net/product_hero/8153/Bryant-Ottoman-Tussah-Snow-T1-322.jpg',
                  __typename: 'HeroImage',
                },
              ],
              images: [
                {
                  sort_order: 1,
                  url: 'https://pv.imgix.net/public_img/8153+1.jpg',
                  __typename: 'Image',
                },
              ],
              price: 3149,
              options: [
                {
                  default_value: '2942',
                  name: 'Fabric',
                  id: 17,
                  popular_values: [
                    '2942',
                    '3824',
                    '4164',
                    '2129',
                    '4035',
                    '298',
                    '3537',
                    '4176',
                    '4031',
                    '3531',
                    '262',
                    '4029',
                    '785',
                    '2738',
                    '4180',
                    '265',
                    '4187',
                  ],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: fabricOption,
                      variant_id: 174114,
                    },
                  ],
                },
              ],
              sku: 'JB13654380',
              slug: 'bryant-ottoman',
              type: {
                name: 'Ottoman',
              },
              fabricSku: '-CF020',
            },
          ],
        },
      },

      {
        subcategoryTitle: 'Loveseats',
        link: '/loveseats',
        products: {
          products: [
            {
              id: 1009,
              name: 'Hughes Loveseat',
              hero_images_min: [
                {
                  sort_order: 1,
                  url:
                    'https://joybird2.imgix.net/product_hero/1009/Hughes-Loveseat-Lucky-Turquoise-T2-020.jpg',
                  __typename: 'HeroImage',
                },
              ],
              images: [
                {
                  sort_order: 1,
                  url:
                    'https://pv.imgix.net/public_img/Gallery-Hughes-Loveseat-1.jpg',
                  __typename: 'Image',
                },
              ],
              price: 1749,
              options: [
                {
                  default_value: '2942',
                  name: 'Fabric',
                  id: 17,
                  popular_values: ['2942', '3824', '4164', '2129'],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: fabricOption,
                      variant_id: 11850,
                    },
                  ],
                },
                {
                  default_value: '757',
                  name: 'Wood Stain',
                  id: 19,
                  popular_values: [],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: woodOptions,
                      variant_id: 17851,
                    },
                  ],
                },
              ],
              sku: 'JB1041200',
              slug: 'hughes-loveseat',
              type: {
                name: 'Loveseat',
              },
              fabricSku: '-CF200',
            },
          ],
        },
      },
      {
        subcategoryTitle: 'Chaises & Daybeds',
        link: '/daybeds-chaises',
        products: {
          products: [
            {
              id: 3374,
              name: 'Anton Daybed',
              hero_images_min: [
                {
                  sort_order: 1,
                  url:
                    'https://joybird2.imgix.net/product_hero/3374/Anton-Daybed-Royal-Peacock-T3-378.jpg',
                  __typename: 'HeroImage',
                },
              ],
              images: [
                {
                  sort_order: 1,
                  url:
                    'https://pv.imgix.net/public_img/Gallery-Anton-Daybed-1.jpg',
                  __typename: 'Image',
                },
              ],
              price: 2599,
              options: [
                {
                  default_value: '2942',
                  name: 'Fabric',
                  id: 17,
                  popular_values: ['2942', '3824', '4164', '2129'],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: fabricOption,
                      variant_id: 70312,
                    },
                  ],
                },
                {
                  default_value: '757',
                  name: 'Wood Stain',
                  id: 19,
                  popular_values: [],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: woodOptions,
                      variant_id: 70313,
                    },
                  ],
                },
              ],
              sku: 'SS1189060',
              slug: 'anton-daybed',
              type: {
                name: 'Daybed',
              },
              fabricSku: '-CF200',
            },
          ],
        },
      },
    ],
  },
  {
    categoryTitle: 'Chairs',
    subcategory: [
      {
        subcategoryTitle: 'Apartment Chairs',
        link: '/apartment-chairs',
        products: {
          products: [
            {
              id: 6653,
              name: 'Soto Concave Arm Chair',
              hero_images_min: [
                {
                  sort_order: 1,
                  url:
                    'https://joybird2.imgix.net/product_hero/6653/Soto-Concave-Arm-Chair-Taylor-Felt-Grey-T2-085.jpg',
                  __typename: 'HeroImage',
                },
              ],
              images: [
                {
                  sort_order: 1,
                  url:
                    'https://pv.imgix.net/public_img/Soto-Concave-Arm-Chair-Taylor-Felt-Grey-T1-289.jpg',
                  __typename: 'Image',
                },
              ],
              price: 1949,
              options: [
                {
                  default_value: '2942',
                  name: 'Fabric',
                  id: 17,
                  popular_values: ['2942', '3824', '4164', '2129'],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: fabricOption,
                      variant_id: 170025,
                    },
                  ],
                },
                {
                  default_value: '3695',
                  name: 'Wood',
                  id: 132,
                  popular_values: [],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: chairWoodOptions,
                      variant_id: 170026,
                    },
                  ],
                },
              ],
              sku: 'JB12804100',
              slug: 'soto-concave-arm-chair',
              type: {
                name: 'Concave Arm Chair',
              },
              fabricSku: '-CF033',
            },
          ],
        },
      },
      {
        subcategoryTitle: 'Accent Chairs',
        link: '/accent-chairs',
        products: {
          products: [
            {
              id: 657,
              name: 'Soto Chair',
              hero_images_min: [
                {
                  sort_order: 1,
                  url:
                    'https://joybird2.imgix.net/product_hero/657/Soto-Chair-Taylor-Felt-Grey-T2-256.jpg',
                  __typename: 'HeroImage',
                },
              ],
              images: [
                {
                  sort_order: 1,
                  url:
                    'https://pv.imgix.net/public_img/Gallery-Soto-Chair-1.jpg',
                  __typename: 'Image',
                },
              ],
              price: 3149,
              options: [
                {
                  default_value: '2942',
                  name: 'Fabric',
                  id: 17,
                  popular_values: ['2942', '3824', '4164', '2129'],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: fabricOption,
                      variant_id: 4348,
                    },
                  ],
                },
                {
                  default_value: '3695',
                  name: 'Wood',
                  id: 132,
                  popular_values: [],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: chairWoodOptions,
                      variant_id: 170363,
                    },
                  ],
                },
              ],
              sku: 'JB1068100',
              slug: 'soto-chair',
              type: {
                name: 'Chair',
              },
              fabricSku: '-CF020',
            },
          ],
        },
      },
      {
        subcategoryTitle: 'Dining Chairs',
        link: '/dining-chairs',
        products: {
          id: 247,
          imageURL: null,
          name: 'Dining Chairs',
          products: [
            {
              id: 1925,
              name: 'Toscano Dining Set',
              hero_images_min: [
                {
                  sort_order: 1,
                  url:
                    'https://joybird2.imgix.net/product_hero/1925/Toscano-Dining-Set-Taylor-Felt-Grey-T3-209.jpg',
                  __typename: 'HeroImage',
                },
              ],
              images: [
                {
                  sort_order: 1,
                  url:
                    'https://pv.imgix.net/public_img/Gallery-Toscano-Dining-Set-1.jpg',
                  __typename: 'Image',
                },
              ],
              price: 3149,
              options: [
                {
                  default_value: '2942',
                  name: 'Fabric',
                  id: 17,
                  popular_values: ['2942', '3824', '4164', '2129'],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: fabricOption,
                      variant_id: 75256,
                    },
                  ],
                },
                {
                  default_value: '3695',
                  name: 'Wood Stain',
                  id: 19,
                  popular_values: [],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: woodOptions,
                      variant_id: 170344,
                    },
                  ],
                },
              ],
              slug: '',
              type: {
                name: 'Dining Room Chair Set',
              },
              fabricSku: '-CF200',
            },
          ],
        },
      },
      {
        subcategoryTitle: 'Swivel Chairs',
        link: '/swivel-chairs',
        products: {
          products: [
            {
              id: 3289,
              name: 'Hughes Swivel Chair',
              hero_images_min: [
                {
                  sort_order: 1,
                  url:
                    'https://joybird2.imgix.net/product_hero/3289/Hughes-Swivel-Chair-Taylor-Felt-Grey-T1-039.jpg',
                  __typename: 'HeroImage',
                },
              ],
              images: [
                {
                  sort_order: 1,
                  url:
                    'https://pv.imgix.net/public_img/Hughes-Swivel-Chair-Taylor-Felt-Grey-T1-039.jpg',
                  __typename: 'Image',
                },
              ],
              price: 1699,
              options: [
                {
                  default_value: '2942',
                  name: 'Fabric',
                  id: 17,
                  popular_values: ['2942', '3824', '4164', '2129'],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: fabricOption,
                      variant_id: 69639,
                    },
                  ],
                },
                {
                  default_value: '757',
                  name: 'Wood Stain',
                  id: 19,
                  popular_values: [],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: woodOptions,
                      variant_id: 69640,
                    },
                  ],
                },
              ],
              sku: 'JB13864910',
              slug: 'hughes-rocking-swivel-chair',
              type: {
                name: 'Swivel Chair',
              },
              fabricSku: '-CF333',
            },
          ],
        },
      },
      {
        subcategoryTitle: 'Rocking Chairs',
        link: '/rocking-chairs',
        products: {
          products: [
            {
              id: 3988,
              name: 'Paley Rocking Chair',
              hero_images_min: [
                {
                  sort_order: 1,
                  url:
                    'https://joybird2.imgix.net/product_hero/3988/hero-paley-rocking-chair-6.jpg',
                  __typename: 'HeroImage',
                },
              ],
              images: [
                {
                  sort_order: 1,
                  url: 'https://pv.imgix.net/public_img/3988+1.jpg',
                  __typename: 'Image',
                },
              ],
              price: 3099,
              options: [
                {
                  default_value: '2942',
                  name: 'Fabric',
                  id: 17,
                  popular_values: ['2942', '3824', '4164', '2129'],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: fabricOption,
                      variant_id: 121415,
                    },
                  ],
                },
                {
                  default_value: '3695',
                  name: 'Wood',
                  id: 132,
                  popular_values: [],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: chairWoodOptions,
                      variant_id: 170330,
                    },
                  ],
                },
              ],
              sku: 'JB13695360',
              slug: 'paley-rocking-chair',
              type: {
                name: 'Rocking Chair',
              },
              fabricSku: '-CF033',
            },
          ],
        },
      },
      {
        subcategoryTitle: 'Recliner Chairs',
        link: '/recliners-gliders',
        products: {
          products: [
            {
              id: 9127,
              name: 'Langham Recliner',
              hero_images_min: [
                {
                  sort_order: 1,
                  url:
                    'https://joybird2.imgix.net/product_hero/9127/Langham-Recliner-Lucky-Divine-T2-080.jpg',
                  __typename: 'HeroImage',
                },
              ],
              images: [
                {
                  sort_order: 1,
                  url:
                    'https://pv.imgix.net/public_img/gallery-langham-recliner-2.jpg',
                  __typename: 'Image',
                },
              ],
              price: 1749,
              options: [
                {
                  default_value: '2942',
                  name: 'Fabric',
                  id: 17,
                  popular_values: ['2942', '3824', '4164', '2129'],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: fabricOption,
                      variant_id: 175442,
                    },
                  ],
                },
                {
                  default_value: '3695',
                  name: 'Wood Stain',
                  id: 19,
                  popular_values: [],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: chairWoodOptions,
                      variant_id: 175680,
                    },
                  ],
                },
              ],
              slug: 'langham-recliner-chair',
              type: {
                name: 'Recliner',
              },
              fabricSku: '-CF020',
            },
          ],
        },
      },
      {
        subcategoryTitle: 'Ottomans & Benches',
        link: '/ottomans',
        products: {
          products: [
            {
              id: 9302,
              name: 'Lyle Leather Ottoman',
              hero_images_min: [
                {
                  sort_order: 1,
                  url:
                    'https://joybird2.imgix.net/product_hero/9302/Lyle-ottoman-academy-cuero-T2-171011-lastudio-0010-hero.jpg',
                  __typename: 'HeroImage',
                },
              ],
              images: [
                {
                  sort_order: 1,
                  url:
                    'https://pv.imgix.net/public_img/gallery-lyle-ottoman-leather-1.jpg',
                  __typename: 'Image',
                },
              ],
              price: 1749,
              options: [
                {
                  default_value: '4026',
                  name: 'Leather',
                  id: 18,
                  popular_values: [],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: leatherOptions,
                      variant_id: 175635,
                    },
                  ],
                },
              ],
              sku: 'JB1371800L',
              slug: 'lyle-leather-ottoman',
              type: {
                name: 'Ottoman',
              },
              fabricSku: '-CF200',
            },
          ],
        },
      },
    ],
  },
  {
    categoryTitle: 'Tables',
    subcategory: [
      {
        subcategoryTitle: 'Coffee Tables',
        link: '/coffee-tables',
        products: {
          products: [
            {
              id: 9360,
              name: 'Hudson Coffee Table',
              hero_images_min: [
                {
                  sort_order: 1,
                  url:
                    'https://joybird2.imgix.net/product_hero/9360/Hudson-coffee-table-T2-Reshoot-171005-lastudio-0047-hero.jpg',
                  __typename: 'HeroImage',
                },
              ],
              images: [
                {
                  sort_order: 1,
                  url:
                    'https://pv.imgix.net/public_img/gallery-hudson-coffee-table-1.jpg',
                  __typename: 'Image',
                },
              ],
              price: 1949,
              options: [],
              sku: 'JB14041300',
              slug: 'lewis-sofa',
              type: {
                name: 'Sofa',
              },
            },
          ],
        },
      },
      {
        subcategoryTitle: 'Dining Tables',
        link: '/dining-tables',
        products: {
          products: [
            {
              id: 1925,
              name: 'Toscano Dining Set',
              hero_images_min: [
                {
                  sort_order: 1,
                  url:
                    'https://joybird2.imgix.net/product_hero/1925/Toscano-Dining-Set-Taylor-Felt-Grey-T3-209.jpg',
                  __typename: 'HeroImage',
                },
              ],
              images: [
                {
                  sort_order: 1,
                  url:
                    'https://pv.imgix.net/public_img/Gallery-Toscano-Dining-Set-1.jpg',
                  __typename: 'Image',
                },
              ],
              price: 2699,
              options: [
                {
                  default_value: '2942',
                  name: 'Fabric',
                  id: 17,
                  popular_values: ['2942', '3824', '4164', '2129'],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: fabricOption,
                      variant_id: 75256,
                    },
                  ],
                },
                {
                  default_value: '3695',
                  name: 'Wood Stain',
                  id: 19,
                  popular_values: [],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: woodOptions,
                      variant_id: 170344,
                    },
                  ],
                },
              ],
              sku: 'JB2595480',
              slug: 'toscano-dining-set',
              type: {
                name: 'Sectional',
              },
              fabricSku: '-CF200',
            },
          ],
        },
      },
      {
        subcategoryTitle: 'End Tables & Entry Tables',
        link: '/end-tables-entry-tables',
        products: {
          products: [
            {
              id: 6391,
              name: 'Stern (Wood Top) End Table',
              hero_images_min: [
                {
                  sort_order: 1,
                  url:
                    'https://joybird2.imgix.net/product_hero/6391/hero-stern-woodtop-end-table-1.jpg',
                  __typename: 'HeroImage',
                },
              ],
              images: [
                {
                  sort_order: 1,
                  url:
                    'https://pv.imgix.net/public_img/Stern-AllWood-Walnut-1.jpg',
                  __typename: 'Image',
                },
              ],
              price: 3149,
              options: [
                {
                  default_value: '3695',
                  name: 'Wood',
                  id: 132,
                  popular_values: [],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: chairWoodOptions,
                      variant_id: 170358,
                    },
                  ],
                },
              ],
              sku: 'JB20694405',
              slug: 'stern-wood-top-table',
              type: {
                name: 'End Table',
              },
            },
          ],
        },
      },
    ],
  },
  {
    categoryTitle: 'Bedroom',
    subcategory: [
      {
        subcategoryTitle: 'Beds',
        link: '/beds',
        products: {
          products: [
            {
              id: 4188,
              name: 'Hughes Bed',
              hero_images_min: [
                {
                  sort_order: 1,
                  url:
                    'https://joybird2.imgix.net/product_hero/9360/Hudson-coffee-table-T2-Reshoot-171005-lastudio-0047-hero.jpg',
                  __typename: 'HeroImage',
                },
              ],
              images: [
                {
                  sort_order: 1,
                  url:
                    'https://pv.imgix.net/public_img/gallery-hudson-coffee-table-1.jpg',
                  __typename: 'Image',
                },
              ],
              price: 1949,
              options: [
                {
                  default_value: '2942',
                  name: 'Fabric',
                  id: 17,
                  popular_values: ['2942', '3824', '4164', '2129'],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: fabricOption,
                      variant_id: 129101,
                    },
                  ],
                },
                {
                  default_value: '757',
                  name: 'Wood Stain',
                  id: 19,
                  popular_values: [],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: woodOptions,
                      variant_id: 129102,
                    },
                  ],
                },
              ],
              sku: 'JB21422500',
              slug: 'hughes-bed',
              type: {
                name: 'Bed',
              },
            },
          ],
        },
      },
      {
        subcategoryTitle: 'Nightstands',
        link: '/nightstands',
        products: {
          products: [
            {
              id: 9380,
              name: 'Fenton Nightstand',
              hero_images_min: [
                {
                  sort_order: 1,
                  url:
                    'https://joybird2.imgix.net/product_hero/9380/Adler-nightstand-walnut-T2-170927-lastudio-0006-web-hero.jpg',
                  __typename: 'HeroImage',
                },
              ],
              images: [
                {
                  sort_order: 1,
                  url:
                    'https://pv.imgix.net/public_img/gallery-adler-nightstand-1.jpg',
                  __typename: 'Image',
                },
              ],
              price: 529,
              options: [],
              sku: 'JB239331010',
              slug: 'fenton-nightstand',
              type: {
                name: 'Nightstand',
              },
            },
          ],
        },
      },
      {
        subcategoryTitle: 'Bedroom Collection',
        link: '/bedroom',
        products: {
          products: [
            {
              images: [
                {
                  url:
                    'https://joybird2.imgix.net/configurations/pid_9132/-CF200-WS03/9132-CF200-WS03-lucca-bed-taylor-felt-grey-t1-2_t.png',
                  __typename: 'Image',
                },
              ],
              options: [],
              slug: `lyle-leather-ottoman-modular`,
              type: {
                name: 'Ottoman',
              },
            },
          ],
        },
      },
      mapSimpleSubcategory({
        subcategoryTitle: 'All Bedroom Furniture',
        link: '/bedroom',
        imageUrl:
          'https://joybird2.imgix.net/configurations/pid_8720/-CF064-WS03/8720-CF064-WS03-camille-bed-key-largo-zenith-teal-t1-2_t.png',
      }),
    ],
  },
  {
    categoryTitle: 'Outdoor',
    subcategory: [
      mapSimpleSubcategory({
        subcategoryTitle: 'Outdoor Sofas',
        link: '/outdoor-sofas',
        imageUrl:
          'https://joybird2.imgix.net/Bondi-Outdoor-Loveseat-Updated-T1-212.jpg',
      }),
      mapSimpleSubcategory({
        subcategoryTitle: 'Outdoor Chairs',
        link: '/outdoor-chairs',
        imageUrl:
          'https://joybird2.imgix.net/Laurel-Outdoor-Lounge-Chair-T1-036.jpg',
      }),
      mapSimpleSubcategory({
        subcategoryTitle: 'Outdoor Tables',
        link: '/outdoor-tables',
        imageUrl:
          'https://joybird2.imgix.net/products_additional/10308/Feature-R-Laguna-Coffee-Table.jpg',
      }),
      mapSimpleSubcategory({
        subcategoryTitle: 'All Outdoor Furniture',
        link: '/outdoor-furniture',
        imageUrl:
          'https://joybird2.imgix.net/Laurel-Outdoor-Collection-T1-196.jpg',
      }),
    ],
  },
  {
    categoryTitle: 'Storage',
    subcategory: [
      {
        subcategoryTitle: 'Storage & Media Consoles',
        link: '/media-consoles',
        products: {
          products: [
            {
              id: 895,
              name: 'Simic Media Console',
              hero_images_min: [
                {
                  sort_order: 1,
                  url:
                    'https://joybird2.imgix.net/product_hero/895/Simic-Media-Console-Walnut-T2-082.jpg',
                  __typename: 'HeroImage',
                },
              ],
              images: [],
              options: [
                {
                  default_value: '3695',
                  name: 'Wood',
                  id: 132,
                  popular_values: [],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: [
                        {
                          id: 3695,
                          sku: '-W03',
                          value: 'Walnut',
                          additional_cost: 0,
                          __typename: 'OptionValue',
                        },
                      ],
                      variant_id: 170335,
                    },
                  ],
                },
              ],
              slug: 'simic-media-console',
              type: {
                name: 'Media Console',
              },
            },
          ],
        },
      },
      {
        subcategoryTitle: 'Bookcases & Wall Units',
        link: '/bookcases-wall-units',
        products: {
          products: [
            {
              id: 9807,
              name: 'Lois Bookcase with Storage',
              hero_images_min: [
                {
                  sort_order: 1,
                  url:
                    'https://joybird2.imgix.net/product_hero/9807/9807-lois-bookcase-with-storage-t1-1_ts.png',
                  __typename: 'HeroImage',
                },
              ],
              images: [
                {
                  sort_order: 1,
                  url:
                    'https://joybird2.imgix.net/product_hero/9807/9807-lois-bookcase-with-storage-t1-1_ts.png',
                  __typename: 'Image',
                },
              ],
              price: 1707,
              options: [],
              sku: 'JB24305400',
              slug: 'lois-bookcase-with-storage',
              type: {
                name: 'Shelf',
              },
            },
          ],
        },
      },
      {
        subcategoryTitle: 'Shelving',
        link: '/shelving',
        products: {
          products: [
            {
              id: 9747,
              name: 'Zuri Shelf',
              hero_images_min: [
                {
                  sort_order: 1,
                  url:
                    'https://joybird2.imgix.net/product_hero/9747/9747-zuri-shelf-t1-2_ts.png',
                  __typename: 'HeroImage',
                },
              ],
              images: [
                {
                  sort_order: 1,
                  url:
                    'https://joybird2.imgix.net/product_hero/9747/9747-zuri-shelf-t1-2_ts.png',
                  __typename: 'Image',
                },
              ],
              price: 164,
              options: [],
              sku: 'JB342471080',
              slug: 'zuri-shelf',
              type: {
                name: 'Shelf',
              },
            },
          ],
        },
      },
    ],
  },
  {
    categoryTitle: 'Decor',
    subcategory: [
      {
        subcategoryTitle: 'Pillows',
        link: '/pillows',
        products: {
          products: [
            {
              id: 5602,
              name: 'Decorative Knife Edge Pillows 18 x 18 (Set of 2)',
              hero_images_min: [
                {
                  sort_order: 1,
                  url:
                    'https://joybird2.imgix.net/product_hero/5602/Decorative-Knife-Edge-Pillow-Taylor-Felt-Grey-T1-017.jpg',
                  __typename: 'HeroImage',
                },
              ],
              images: [
                {
                  sort_order: 1,
                  url:
                    'https://pv.imgix.net/public_img/Decorative-Knife-Edge-Pillows-Taylor-Felt-Grey-T1-171.jpg',
                  __typename: 'Image',
                },
              ],
              price: 1949,
              options: [
                {
                  default_value: '2942',
                  name: 'Fabric',
                  id: 17,
                  popular_values: ['2942', '3824', '4164', '2129'],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: fabricOption,
                      variant_id: 152357,
                    },
                  ],
                },
              ],
              sku: 'JB23913430',
              slug: 'decorative-pillows',
              type: {
                name: 'Pillow',
              },
            },
          ],
        },
      },
      {
        subcategoryTitle: 'Throws',
        link: '/throws',
        products: {
          products: [
            {
              id: 1584,
              name: 'Silas Throw',
              hero_images_min: [],
              images: [
                {
                  sort_order: 1,
                  url:
                    'https://pv.imgix.net/public_img/gallery-silas-throw.jpg',
                  __typename: 'Image',
                },
              ],
              price: 2699,
              options: [],
              sku: 'JB2595480',
              slug: 'silas-throw',
              type: {
                name: 'Throw',
              },
            },
          ],
        },
      },
      {
        subcategoryTitle: 'Rugs',
        link: '/rugs',
        products: {
          products: [
            {
              id: 9224,
              name: 'Aina Rug',
              hero_images_min: [
                {
                  sort_order: 1,
                  url:
                    'https://joybird2.imgix.net/product_hero/9224/Aina-Rug-T1-093.jpg',
                  __typename: 'HeroImage',
                },
                {
                  sort_order: 2,
                  url:
                    'https://joybird2.imgix.net/product_hero/6391/hero-stern-woodtop-end-table-6.jpg',
                  typename: 'HeroImage',
                },
                {
                  sort_order: 3,
                  url:
                    'https://joybird2.imgix.net/product_hero/6391/hero-stern-woodtop-end-table-4.jpg',
                  __typename: 'HeroImage',
                },
                {
                  sort_order: 4,
                  url:
                    'https://joybird2.imgix.net/product_hero/6391/hero-stern-woodtop-end-table-5.jpg',
                  _typename: 'HeroImage',
                },
                {
                  sort_order: 5,
                  url:
                    'https://joybird2.imgix.net/product_hero/6391/hero-stern-woodtop-end-table-2.jpg',
                  __typename: 'HeroImage',
                },
                {
                  sort_order: 6,
                  url:
                    'https://joybird2.imgix.net/product_hero/6391/hero-stern-woodtop-end-table-3.jpg',
                  __typename: 'HeroImage',
                },
              ],
              images: [
                {
                  sort_order: 1,
                  url: 'https://pv.imgix.net/public_img/gallery-aina-rug-1.jpg',
                  __typename: 'Image',
                },
              ],
              price: 3149,
              options: [
                {
                  default_value: '4336',
                  name: 'Size',
                  id: 158,
                  popular_values: [],
                  totalValuesCount: null,
                  values: [
                    {
                      option_values: [
                        {
                          id: 4336,
                          sku: "-RUG5'3ROUND",
                          value: "5'3 ft Round",
                          additional_cost: 0,
                          __typename: 'OptionValue',
                        },
                        {
                          id: 4016,
                          sku: "-RUG5'3x7'3",
                          value: "5'3 ft x 7'3 ft",
                          additional_cost: 40,
                        },
                        {
                          id: 4071,
                          sku: "-RUG7'10ROUND",
                          value: "7'10 ft Round",
                          additional_cost: 250,
                        },
                        {
                          id: 4060,
                          sku: "-RUG7'10x10'3",
                          value: "7'10 ft x 10'3 ft",
                          additional_cost: 140,
                        },
                        {
                          id: 4078,
                          sku: "-RUG9'3X12'6",
                          value: "9'3 ft x 12'6 ft",
                          additional_cost: 280,
                        },
                        {
                          id: 4394,
                          sku: "-6'7x9OVAL",
                          value: "6'7 ft x 9 Oval",
                          additional_cost: 230,
                        },
                      ],
                      variant_id: 175532,
                    },
                  ],
                },
              ],
              sku: 'JB20694405',
              slug: 'aina-rug',
              type: {
                name: 'Rug',
              },
            },
          ],
        },
      },
      {
        subcategoryTitle: 'Poufs & Cubes',
        link: '/poufs',
        products: {
          products: [
            {
              images: [
                {
                  url:
                    'https://joybird2.imgix.net/configurations/pid_8499/-CF416-WS03/8499-CF416-WS03-cort-cube-ottoman-prime-peacock-t1-2_t.png',
                  __typename: 'Image',
                },
              ],
              options: [],
              slug: `poufs-and-cubes-modular`,
              type: {
                name: 'Poufs & Cubes',
              },
            },
          ],
        },
      },
      {
        subcategoryTitle: 'Planters',
        link: '/planters',
        products: {
          products: [
            {
              id: 9193,
              name: 'Zane (Small) Planter',
              hero_images_min: [],
              images: [
                {
                  sort_order: 1,
                  url:
                    'https://pv.imgix.net/public_img/Gallery-Zane-Small-Planter.jpg',
                  __typename: 'Image',
                },
              ],
              price: 3149,
              options: [],

              slug: 'zane-small-planter',
              type: {
                name: 'Planter',
              },
            },
          ],
        },
      },
      {
        subcategoryTitle: 'Wall Decor & Wallpaper',
        link: '/wall-art',
        products: {
          products: [
            {
              id: 1352,
              name: 'Vernon Clock',
              hero_images_min: [],
              images: [
                {
                  sort_order: 1,
                  url:
                    'https://pv.imgix.net/public_img/gallery-vernon-clock.jpg',
                  __typename: 'Image',
                },
              ],
              price: 3149,
              options: [],

              slug: 'vernon-clock',
              type: {
                name: 'Clocks',
              },
            },
          ],
        },
      },
      {
        subcategoryTitle: 'Lighting',
        link: '/all-lighting',
        products: {
          products: [
            {
              id: 6549,
              name: 'Savannah Table Lamp',
              hero_images_min: [
                {
                  sort_order: 1,
                  url:
                    'https://joybird2.imgix.net/product_hero/6549/Savannah-Table-Lamp-T1-002.jpg',
                  __typename: 'HeroImage',
                },
              ],
              images: [
                {
                  sort_order: 1,
                  url:
                    'https://pv.imgix.net/public_img/Savannah-Table-Lamp-T1-002.jpg',
                  __typename: 'Image',
                },
              ],
              price: 3149,
              options: [],

              slug: 'savannah-table-lamp',
              type: {
                name: 'Table Lamp',
              },
            },
          ],
        },
      },
      {
        subcategoryTitle: 'Mirrors',
        link: '/mirrors',
        products: {
          products: [
            {
              id: 10060,
              name: 'Mika Shelf Mirror',
              hero_images_min: [],
              images: [
                {
                  sort_order: 1,
                  url:
                    'https://pv.imgix.net/public_img/Gallery-Mika-Shelf-Mirror-Square-T1-001.jpg',
                  __typename: 'Image',
                },
              ],
              price: 3149,
              options: [],

              slug: 'mika-shelf-mirror',
              type: {
                name: 'Mirror',
              },
            },
          ],
        },
      },
      mapSimpleSubcategory({
        subcategoryTitle: 'All Decor',
        link: '/decoration-accessories',
        imageUrl:
          'https://joybird2.imgix.net/product_hero/9398/9398-bronze-intersections-wallpaper-t1-1_ts.png',
      }),
    ],
  },
];

export default shopCategories;
